import { apis } from "service";

const path = {
    pid: "c6d12f0c-7e49-449b-b5e4-98713408de66",
    aid: "99b487f4-04d6-451d-b977-dca884d4f074"
};

export const getProducts = (payload) =>
  apis.get(
    `https://smartstock-faas.bfast.mraba.co.tz/shop/${path?.pid}/${path?.aid}/stock/products`,
    payload,
  );

export const getCategories = (payload) =>
  apis.get(
    `https://smartstock-faas.bfast.mraba.co.tz/shop/${path?.pid}/${path?.aid}/stock/categories`,
    payload,
  );

export const getCategoryFromProduct = (payload) =>
  apis.post(
    `https://smartstock-faas.bfast.mraba.co.tz/shop/${path?.pid}/${path?.aid}/report/custom`,
    payload,
  );

export const submitOrder = (payload) =>
  apis.post(
    `https://smartstock-faas.bfast.mraba.co.tz/shop/${path?.pid}/${path?.aid}/sale/orders/online`,
    payload
  );

export const getOnlineOrdersApi = (payload) =>
  apis.get(
    `https://smartstock-faas.bfast.mraba.co.tz/shop/${path?.pid}/${path?.aid}/sale/orders/online?reference=${payload?.reference}`,
    payload,
  );